import * as taskName from './task-name'
import * as processUI from '../../process-ui'
import * as processAction from '../../process-action'

export default {
    taskName: taskName.PRINT_SURGICAL_GUIDE,
    taskOverviewProps: {},
    widgetList: [
        {
            component: processUI.OVERVIEW,
        },
        {
            component: processUI.SALES_ORDER_CUSTOMER_WIDGET,
            readOnly: true,
        },
        {
            component: processUI.COMMENT_LIST,
            readOnly: true,
        },
        {
            component: processUI.CUSTOMER_IMAGE_WIDGET,
        },
        {
            component: processUI.SCAN_FILE_UPLOAD_WIDGET,
        },
        {
            component: processUI.PRODUCTION_FILE_UPLOAD_WIDGET,
        },
    ],
    actionList: [
        {
            action: processAction.PROCESS_INSTANCE,
            taskPath: ['processInstance'],
        },
        {
            action: processAction.TREATMENT_PLAN,
            taskPath: ['objectDetail', 'customer', 'treatmentPlanList', 0],
        },
        {
            action: processAction.SALES_ORDER,
            taskPath: ['objectDetail'],
        },
        {
            action: processAction.CUSTOMER,
            taskPath: ['objectDetail', 'customer'],
        },
    ],
}



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/implant-treatment/print-surgical-guide.js